import { call, put, takeEvery } from 'redux-saga/effects'
import API from '../../API';
import { toastr } from 'react-redux-toastr'

async function getApi(data) {
    const apiUrl = API.baseURL + `/service_list`;
    const requestOptions = {
        method: 'GET',
        headers: API.options.headers,
    };
    try {
        const response = await fetch(apiUrl, requestOptions);
        return await response.json();
    } catch (error) {
        throw error;
    }
}

function* getServiceTypes(action) {
    try {
        const response = yield call(getApi, action.data);
        if (response.code == 200 || response.code == 201) {
            // toastr.success('Pegister personal Success', 'You are successfully completed the first step ');
        } else {
            // response.errors.length!=0&&toastr.error('Pegister personal  failed', response.errors[0]);
        }
        // history.push('/');
        yield put({ type: 'GET_SERVICE_TYPES_SUCCESS', services: response.data });
    } catch (e) {
        yield put({ type: 'GET_SERVICE_TYPES_FAILED', message: e.message });
    }
}

function* serviceTypeList() {
    yield takeEvery('GET_SERVICE_TYPES_REQUESTED', getServiceTypes);
}

export default serviceTypeList;